/* Paint colour swatches on collection cards (snippets/co-card-swatches.liquid).
   Clicking a swatch shows that colour on the card instead of leaving the page:
   the card photo swaps to the colour's photo, the selected ring moves, and the
   card's own links (image, title, View button) point at that colour's variant.
   Without JS each swatch is still a plain link to its variant.
   Loaded by main-collection-product-grid only when the swatches are on.
   Delegated from document, so it keeps working after filtering/sorting
   re-renders the grid. */
(function () {
  'use strict';

  // Same widths the card image uses (snippets/card-product.liquid).
  var WIDTHS = [165, 360, 535, 750, 940, 1100];

  function atWidth(url, width) {
    return /[?&]width=\d+/.test(url)
      ? url.replace(/([?&])width=\d+/, '$1width=' + width)
      : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  // retinaMobile mirrors the card's <source>: half-width files, full-width descriptors.
  function srcsetFor(url, retinaMobile) {
    return WIDTHS.map(function (w) {
      return atWidth(url, retinaMobile ? Math.floor(w / 2) : w) + ' ' + w + 'w';
    }).join(', ');
  }

  function setPicture(picture, url, alt) {
    var img = picture.querySelector('img');
    var source = picture.querySelector('source');
    if (source) source.setAttribute('srcset', srcsetFor(url, true));
    if (picture.hasAttribute('data-hq')) picture.setAttribute('data-hq', atWidth(url, 2000));
    if (img) {
      img.setAttribute('srcset', srcsetFor(url, false));
      img.setAttribute('src', url);
      if (alt !== undefined) img.setAttribute('alt', alt);
    }
  }

  function select(swatch) {
    var card = swatch.closest('.card-wrapper');
    var row = swatch.closest('.co-card-swatches');
    if (!card || !row) return;

    row.querySelectorAll('.co-card-swatches__swatch').forEach(function (s) {
      var on = s === swatch;
      s.classList.toggle('is-active', on);
      if (on) s.setAttribute('aria-current', 'true');
      else s.removeAttribute('aria-current');
    });

    var url = swatch.getAttribute('href');
    card.querySelectorAll('a.card__media, a.card-information__text, a.full-unstyled-link, .card-information__button a').forEach(function (a) {
      a.setAttribute('href', url);
    });

    var image = swatch.getAttribute('data-image');
    if (!image) return; // no photo for this colour yet: keep the current one

    var pictures = card.querySelectorAll('a.card__media .media > picture');
    if (pictures[0]) setPicture(pictures[0], image, swatch.getAttribute('data-alt') || '');

    // The hover photo must stay in the chosen colour, or be switched off.
    if (pictures[1]) {
      var hover = swatch.getAttribute('data-hover-image');
      if (hover) {
        pictures[1].style.removeProperty('display');
        setPicture(pictures[1], hover, swatch.getAttribute('data-hover-alt') || '');
      } else {
        pictures[1].style.setProperty('display', 'none');
      }
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('.co-card-swatches__swatch');
    if (!swatch) return;
    // Let cmd/ctrl/shift/middle-click open the colour in a new tab as a normal link.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    select(swatch);
  });
})();
